import React from 'react'
import HeroImage from "../assets/services.jpg"
import HeroComp from '../components/HeroComp'
import PricingCard from '../components/PricingCard'
import SerCard from '../components/SerCard'


export default function Services() {
  return (
    <>
      <HeroComp heading="Services" paragraph="Our Sevices are given below. Pick that which is Great for you" src={HeroImage} />
      <SerCard />
      <PricingCard />
    </>
  )
}
